import React, { useState } from 'react';
import './Navbar.css'; // Include CSS file for styling (optional)
import { useAdmin } from '../Admin/AdminContext';

import { useNavigate } from 'react-router-dom';
import { Link, useLocation } from 'react-router-dom';
const AdminNavbar = () => {
      const navigate = useNavigate();
  const { role } = useAdmin();
    const location = useLocation(); // Get the current location
    const [isMenuOpen, setIsMenuOpen] = useState(false); // State to toggle menu
    
    
  
    const toggleMenu = () => {
      setIsMenuOpen(!isMenuOpen); // Toggle the menu visibility
    };
  // Handle logout functionality
  const handleLogout = () => {
    // Clear the authentication token
    console.log("Here")
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      console.log(`${key}: ${localStorage.getItem(key)}`);
    }

    localStorage.removeItem('authToken');
  
    // Redirect to the login page
    navigate('/Admin');
};
  return (
    <header className="header">
      <div className="logo">
        <Link to="/Admin/AdminPortal">
          <img src="/1.png" alt="Logo" />
        </Link>
      </div>
      <button
        className="menu-toggle"
        onClick={toggleMenu}
        aria-expanded={isMenuOpen}
        aria-controls="navbar"
      >
        {isMenuOpen ? (
          <span className="cross">✖</span>
        ) : (
          <>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </>
        )}
      </button>
      
      <nav 
      id="navbar"
      className={`navbar ${isMenuOpen ? 'active' : ''}`} 
      onClick={toggleMenu}
      >
        
       <Link to="/Admin/AdminPortal" className={location.pathname==='/Admin/AdminPortal'? 'active':''}
       onClick={toggleMenu}>Home</Link>   
       <Link to="/Admin/AdminPortal/AddCar"className={location.pathname==="/Admin/AdminPortal/AddCar"    ? 'active':''}onClick={toggleMenu}>Add Car</Link>  
       
       <Link to="/Admin/AdminPortal/CarReview"className={location.pathname==="/Admin/AdminPortal/CarReview"    ? 'active':''}onClick={toggleMenu}>Review Vehicles</Link>  
       <Link to="/Admin/AdminPortal/DeleteCar"   className={location.pathname==="/Admin/AdminPortal/DeleteCar"  ? 'active':''}onClick={toggleMenu}>Update Car</Link>           
       <Link to="/Admin/AdminPortal/AddAdmin" className={location.pathname==="/Admin/AdminPortal/AddAdmin"? 'active':''}onClick={toggleMenu}>Add Admin</Link>   
       <Link to="/Admin/AdminPortal/DeleteFeatures"  className={location.pathname==="/Admin/AdminPortal/DeleteFeatures" ? 'active':''}onClick={toggleMenu}>Delete Features</Link> 
       <Link to="/Admin/AdminPortal/DeleteReviews"  className={location.pathname==="/Admin/AdminPortal/DeleteReviews" ? 'active':''}onClick={toggleMenu}>Delete Reviews</Link> 
       <Link to="/Admin/AdminPortal/Aboutus" className={location.pathname==="/Admin/AdminPortal/Aboutus" ? 'active':''}onClick={toggleMenu}>Change About Us</Link> 
       <Link to="/Admin/AdminPortal/Location"className={location.pathname==="/Admin/AdminPortal/Location" ? 'active':''}onClick={toggleMenu}>Change Location</Link> 
       <Link to="/Admin/AdminPortal/AddWhyus"     className={location.pathname==="/Admin/AdminPortal/AddWhyus"   ? 'active':''}onClick={toggleMenu}>Add Features</Link>      
       <Link to="/Admin/AdminPortal/Timings"      className={location.pathname==="/Admin/AdminPortal/Timings"    ? 'active':''}onClick={toggleMenu}>Change Timings</Link>  
       <Link to="/Admin/AdminPortal/Contact"  className={location.pathname==="/Admin/AdminPortal/Contact"    ? 'active':''}onClick={toggleMenu}>Change Contact</Link>  
       <Link to="/Admin/AdminPortal/email" className={location.pathname==="/Admin/AdminPortal/email"    ? 'active':''}onClick={toggleMenu}>Email Set</Link>  
       <button
  onClick={handleLogout}
  className="m-button"
>
  LogOut
</button>

        </nav>
        </header>
  );
};

export default AdminNavbar;
